<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="container-fluid mt--6">
      <b-row class="justify-content-center">
        <b-col lg="8" class="card-wrapper ct-example">
          <!-- Styles -->
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Add New</h3>
            </b-card-header>
            <b-card-body>
              <form @submit="postBulletin">
                <b-row class="form-group">
                  <b-col md="6">
                    <base-input label="Title" v-model="inputs.title" />
                  </b-col>
                  <b-col md="6">
                    <base-input label="Type">
                      <select class="form-control" v-model="inputs.type">
                        <option value="info">Information</option>
                        <option value="warning">Warning</option>
                        <option value="danger">Urgent</option>
                        <option value="success">Success</option>
                      </select>
                    </base-input>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="6">
                    <base-input
                      label="Schedule At"
                      type="datetime-local"
                      v-model="startDate"
                      aria-disabled="true"
                      disabled="true"
                      id="example-datetime-local-input"
                    />
                  </b-col>
                  <b-col md="6">
                    <base-input
                      label="Expire At"
                      type="datetime-local"
                      v-model="endDate"
                      id="example-datetime-local-input"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="6">
                    <base-input label="Bulletin Message">
                      <textarea
                        v-model="inputs.message"
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="1"
                      ></textarea>
                    </base-input>
                  </b-col>
                  <b-col md="6">
                    <base-input label="Audience">
                      <select class="form-control" v-model="inputs.audience">
                        <option value="all">All</option>
                        <option value="internal">Air India</option>
                        <option value="external">External</option>
                      </select>
                    </base-input>
                  </b-col>
                </b-row>
                <!-- <b-row class="form-group">
                  <b-col md="12">
                    <b-form-file
                      @change="filesChange"
                      placeholder="Select file"
                      drop-placeholder="Drop file here..."
                    ></b-form-file>
                  </b-col>
                </b-row> -->
                <b-row class="form-group">
                  <b-col md="12" class="text-right">
                    <base-button icon type="success" nativeType="submit">
                      <span class="btn-inner--icon"
                        ><i class="ni ni-bag-17"></i
                      ></span>
                      <span class="btn-inner--text">Post</span>
                    </base-button>
                  </b-col>
                </b-row>
              </form>
            </b-card-body>
          </b-card>
          <!-- Colors -->
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Bulletins</h3>
            </b-card-header>
            <b-card-body>
              <b-col
                cols="12"
                class="
                  d-flex
                  justify-content-center justify-content-sm-between
                  flex-wrap
                "
              >
                <base-input>
                  <select
                    class="form-control"
                    v-model.number="page.page_size"
                    placeholder="Per page"
                    @change="getData"
                  >
                    <option value="3">3</option>
                    <option value="6">6</option>
                    <option value="9">9</option>
                    <option value="12">12</option>
                    <option value="30">30</option>
                  </select>
                </base-input>
                <!-- <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                    :name="item"
                  >
                  </el-option>
                </el-select> -->

                <div>
                  <base-input
                    v-model="searchQuery"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                  >
                  </base-input>
                </div>
              </b-col>

              <b-col
                md="4"
                v-for="bulletin in bulletins"
                :key="bulletin._id"
                class="d-inline-block"
              >
                <card class="p-3">
                  <!-- Card body -->
                  <b-card-title title-tag="h3" class="mb-3 clsBulletinTitle">{{
                    bulletin.subject
                  }}</b-card-title>
                  <b-card-text class="mb-4 clsBulletinText">{{
                    bulletin.message
                  }}</b-card-text>
                  <base-button
                    type="primary"
                    @click="getBulletin(bulletin.bulletinId)"
                    >Open</base-button
                  >
                </card>
              </b-col>
            </b-card-body>

            <div
              slot="footer"
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <!-- <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                </span>
              </p>

            </div> -->
              <base-pagination
                class="pagination-no-border"
                :value="parseInt(page.page_no)"
                :perPage="parseInt(page.page_size)"
                :total="parseInt(page.total)"
                :size="'5'"
                @change="paginationChanged($event)"
              >
              </base-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        id="modal1"
        ref="modal"
        title="Update Bulletin"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-row class="form-group">
            <b-col md="6">
              <base-input label="Title" v-model="selectedBulletin.title" />
            </b-col>
            <b-col md="6">
              <base-input label="Type">
                <select class="form-control" v-model="selectedBulletin.type">
                  <option value="info">Information</option>
                  <option value="warning">Warning</option>
                  <option value="danger">Urgent</option>
                  <option value="success">Success</option>
                </select>
              </base-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <base-input
                label="Schedule At"
                type="datetime-local"
                v-model="selectedStartDate"
                id="selectedEndDate"
              />
            </b-col>
            <b-col md="6">
              <base-input
                label="Expire At"
                type="datetime-local"
                v-model="selectedEndDate"
                id="selectedStartDate"
              />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <base-input label="Bulletin Message">
                <textarea
                  v-model="selectedBulletin.message"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="1"
                ></textarea>
              </base-input>
            </b-col>
            <b-col md="6">
              <base-input label="Audience">
                <select
                  class="form-control"
                  v-model="selectedBulletin.audience"
                >
                  <option value="all">All</option>
                  <option value="internal">Air India</option>
                  <option value="external">External</option>
                </select>
              </base-input>
            </b-col>
          </b-row>
        </form>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
// "success", "info", "warning", "danger"
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BaseHeader from "@/components/BaseHeader";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import moment from "moment";
import { mapGetters } from "vuex";
import { API } from "../../services/api.service";

export default {
  data: function() {
    return {
      inputs: {
        title: "Informational Message",
        message: "Welcome to our new Portal 🎉",
        type: "info",
        isHtml: false,
        start_date: new Date(),
        end_date: "2021-11-18T16:50:35.196Z",
        audience: "all"
      },
      checkboxes: {
        unchecked: false,
        checked: true,
        uncheckedDisabled: false,
        checkedDisabled: true
      },
      page: {
        page_size: 12,
        page_no: 1,
        total: 0
      },
      bulletins: [],
      selectedRows: [],
      selectedBulletin: {}
    };
  },
  filters: {
    formattedDate(value) {
      return moment(value);
    }
  },
  created() {
    this.getData();
  },
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    BaseHeader,
    RouteBreadcrumb
  },
  computed: {
    ...mapGetters("user", ["getToken"]),
    selectedStartDate: {
      get() {
        return this.selectedBulletin.start_date
          ? moment(this.selectedBulletin.start_date).format(
              "yyyy-MM-DD[T]hh:mm"
            )
          : "";
      },
      // setter
      set(newValue) {
        this.selectedBulletin.start_date = new Date(newValue);
      }
    },
    selectedEndDate: {
      get() {
        return this.selectedBulletin.end_date
          ? moment(this.selectedBulletin.start_date).format(
              "yyyy-MM-DD[T]hh:mm"
            )
          : "";
      },
      // setter
      set(newValue) {
        this.selectedBulletin.end_date = new Date(newValue);
      }
    },
    startDate: {
      get() {
        return this.inputs.start_date
          ? moment(this.inputs.start_date).format("yyyy-MM-DD[T]hh:mm")
          : "";
      },
      // setter
      set(newValue) {
        this.inputs.start_date = new Date(newValue);
      }
    },
    endDate: {
      get() {
        return this.inputs.end_date
          ? moment(this.inputs.start_date).format("yyyy-MM-DD[T]hh:mm")
          : "";
      },
      // setter
      set(newValue) {
        this.inputs.end_date = new Date(newValue);
      }
    }
  },
  methods: {
    getBulletin(id) {
      API.GET_BULLETIN_BY_ID(id)
        .then(res => {
          try {
            if (res.data.ok) {
              this.selectedBulletin = res.data.result;
              this.showModal();
            } else if (err) {
              throw err;
            }
          } catch (e) {}
        })
        .catch(err => {
          console.log(err);
        });
    },
    getData() {
      let params = {
        page_size: this.page.page_size,
        page_no: this.page.page_no
      };
      API.GET_BULLETIN({ params })
        .then(res => {
          try {
            if (res.data.ok) {
              this.tableData = res.data.result.items;
              this.bulletins = res.data.result.items;
              this.page = res.data.result.page;
            } else if (err) {
              throw err;
            }
          } catch (e) {}
        })
        .catch(err => {
          console.log(err);
        });
    },
    postBulletin(e) {
      e.preventDefault();
      API.PUT_BULLETIN(this.inputs)
        .then(res => {
          try {
            if (res.data.ok) {
              this.getData();
              swal.fire({
                title: `Bulletin Posted Successfully!`,
                buttonsStyling: false,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill"
              });
            } else if (err) {
              throw err;
            }
          } catch (e) {}
        })
        .catch(err => {
          swal.fire({
            title: `${err}`,
            buttonsStyling: false,
            type: "error",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
        });
    },
    showModal() {
      this.$bvModal.show("modal1");
    },
    hideModal() {
      this.$bvModal.hide("modal1");
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.name = "";
      this.nameState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name);
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal1");
      });
    },
    filesChange(files) {
      this.inputs.file = files;
    },
    paginationChanged(page) {
      this.page.page_no = page;
      this.getData();
    },
    handleLike(index, row) {
      swal({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill"
      });
    },
    handleEdit(index, row) {
      swal({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill"
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style scoped>
.clsBulletinText {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
  min-height: 4.5em;
}
.clsBulletinTitle {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
